import { useCallback, useState } from 'react';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';

import { QueryDropdown } from 'basic-components';
import Query from 'dashboard-services/api/Query';

import getApiConfig from 'api/ApiConfig';
import { dataStorageQueries } from 'queries/modules/datastorage';

const select = data => data?.pages?.flatMap(page => page?.items)?.map(item => ({ value: item?.name, label: item?.name }))
const EMPTY_ARRAY = [];
const HolidayCalendar = ({
  value,
  onChange,
  size = undefined,
  menuPortalTarget = undefined,
  ref,
  ...props
}) => {
  const dispatch = useDispatch(),
        getApiConfigLocal = useCallback(() => dispatch(getApiConfig()), [dispatch]),
        getQueryBuilder = useCallback(() => 
          new Query.Builder(getApiConfigLocal())
            .withFetching(false)
        , [getApiConfigLocal]),
        [calendarsQuery, setCalendarsQuery] = useState(),
        { fetchNextPage: fetchMoreCalendars, isFetching: isFetchingCalendars, isFetchingNextPage: isFetchingNextPageCalendars, data: calendars = EMPTY_ARRAY } = dataStorageQueries.useGetHolidayCalendars({ query: calendarsQuery, getQueryBuilder, size: 100, select })
  return (
    <QueryDropdown
        {...props}
        defaultValue={value !== "" ? String(value) : undefined}
        fetchNextPage={fetchMoreCalendars}
        isFetching={isFetchingCalendars || isFetchingNextPageCalendars}
        menuPortalTarget={menuPortalTarget || document.body}
        onChange={onChange}
        onInputChange={setCalendarsQuery}
        options={calendars}
        placeholder="Select"
        ref={ref}
        size={size}
    />
  )
}

HolidayCalendar.displayName = "HolidayCalendar"

HolidayCalendar.propTypes = {
  menuPortalTarget: PropTypes.any,
  onChange: PropTypes.func.isRequired,
  size: PropTypes.string,
  value: PropTypes.any.isRequired
}

export default HolidayCalendar;